		<div id="login">
			<div class="imagery" style="background-image:url(assets/images/road-1.jpg);"></div>
			<div class="dialogue">
				<div class="panel">
					<div class="titleBar">
						<svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-user"></use></svg>
						<div class="title">Set Password</div>
					</div><!-- titleBar -->
                    <p class="text-muted">Enter your password below.</p>
                    <p class="footnote italic" >
                        Note:<br/>
                        Passwords must have at least 8 characters.<br/>
                        Passwords must have at least one digit.<br/>
                        Passwords must have a mix of upper and lower case characters.<br/>
                        Passwords must have at least one special character.
                    </p>
                    <form name="form" (ngSubmit)="f.form.valid && reset()" #f="ngForm" novalidate>
                        <div class="inputWrap withHint">		
                            <input type="password" placeholder="New Password" name="password"
                                [(ngModel)]="model.password" #password="ngModel" 
                                required minlength="6" maxlength="15" validateEqual="confirmPassword" reverse="true" />
                            <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-key"></use></svg>
                            <div  *ngIf="f.submitted && !password.valid" class="login-validation">
                                <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                                <span>Password is required (6 to 15 characters)</span>
                            </div><!-- validation -->
                        </div><!-- inputWrap --> 
                        <div class="inputWrap withHint">		
                            <input type="password" placeholder="Password" name="confirmPassword" 
                                [(ngModel)]="model.confirmPassword" #confirmPassword="ngModel" 
                                required minlength="6" maxlength="15" validateEqual="password" />
                            <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-key"></use></svg>
                            <div  *ngIf="f.submitted && !confirmPassword.valid" class="login-validation">
                                <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>
                                <span>Password mismatch</span>
                            </div><!-- validation -->
                        </div><!-- inputWrap --> 

                        <div class="inputWrap withHint text-right">
                            <button type="submit" class="cta primary ladda" data-style="slide-right" [ladda]="isLoading">Submit</button>
                        </div>
                    </form>
				</div><!-- panel -->
			</div><!-- dialogue -->
            <div *ngIf= "alert" class="announce visible announce-margin">
                <div class="area">
                    <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-alert"></use></svg>&nbsp;<span>{{alert.message}} </span>            
                <div>
            </div>              
		</div><!-- login -->
